
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexCQsu7M_H3gBwbH9kEvKhE3biZ8fZgVklfGXRAzz1K6AMeta } from "/home/vsts/work/1/s/frontend/pages/auto-qa/index.vue?macro=true";
import { default as indexCIZGGs1bxBvO3kXfORGIqy1KMpPaO3ao96E_WCz4bDcMeta } from "/home/vsts/work/1/s/frontend/pages/auto-qa/schedules/designer/[[id]]/index.vue?macro=true";
import { default as indexCLGWLKeW7dHwst0_7Ko8_45j6gDy2d6Qnw08RnWHa4Q90Meta } from "/home/vsts/work/1/s/frontend/pages/auto-qa/scorecards/designer/[[id]]/index.vue?macro=true";
import { default as indexFuSRjEyL1ZhAjMGxhboe4D6qwlHumjbI4109ql4jOuIMeta } from "/home/vsts/work/1/s/frontend/pages/index.vue?macro=true";
import { default as indexLRMqHAF5L3_EoMGh9MqOTQXVRYF9wjaaNx5o8TPJ1WYMeta } from "/home/vsts/work/1/s/frontend/pages/interaction/[id]/index.vue?macro=true";
import { default as indexWj5mu1U5TcmWkORbRmPncXvF6ave2Y59DLCtdbUvQkkMeta } from "/home/vsts/work/1/s/frontend/pages/interactions/index.vue?macro=true";
import { default as indextxmpD0NLiylCG8zCCjgZtM5HrtaOvTk9ZHVlMxcQLrEMeta } from "/home/vsts/work/1/s/frontend/pages/landing/index.vue?macro=true";
import { default as indexSRRXWujxOFb_45JLeHuYdW6elKsaT7IOLooo3hFiFJPxkMeta } from "/home/vsts/work/1/s/frontend/pages/maintenance/index.vue?macro=true";
import { default as indexiol2wFZCm8QJ2oAyoBl4qGW_45k6pVeQRpW3YHOAljMc0Meta } from "/home/vsts/work/1/s/frontend/pages/objections/index.vue?macro=true";
import { default as indexRD0Kv3SnjQ1B7ivS47vqiHs1CB8Ser8D9EZhLSV7264Meta } from "/home/vsts/work/1/s/frontend/pages/overview/index.vue?macro=true";
import { default as indexrjUZpY_45hjJptUJCUWWzpt9nSrH_u5rv_bf4lGJ4s4AcMeta } from "/home/vsts/work/1/s/frontend/pages/pdfExport/index.vue?macro=true";
import { default as index65ODQZmLCHFepT897IeUw4Cfazfhf_vyzud4zXVPdKMMeta } from "/home/vsts/work/1/s/frontend/pages/performance/index.vue?macro=true";
import { default as indexGJJNclDeYxhObd51m8MjFlsdpLxpg_un33RIYhp48sEMeta } from "/home/vsts/work/1/s/frontend/pages/playback/index.vue?macro=true";
import { default as index2aG2canzB_5IRkpWAkdnlDd9x7kjuiXUggE0Jspsv_45cMeta } from "/home/vsts/work/1/s/frontend/pages/prompt-studio/index.vue?macro=true";
import { default as indexIpSPrdYugpkOYpy6fqrs5EUu37mA7pUahdAK63z9Ij4Meta } from "/home/vsts/work/1/s/frontend/pages/scorecards/designer/[[id]]/index.vue?macro=true";
import { default as indexKfDJ6LXGmo8X7RhPd0kNs9rSKtWX5kMjdyBAf_YCWYwMeta } from "/home/vsts/work/1/s/frontend/pages/scorecards/index.vue?macro=true";
import { default as indexp49QsU_45j12Sd60L2Aw9gLzeyvKf2VP3ShY0OQCn2jOoMeta } from "/home/vsts/work/1/s/frontend/pages/scoring/index.vue?macro=true";
import { default as index1XCdv4fosXiday5au8Fs0NZGDzBt__45SaC82RpYBLICUMeta } from "/home/vsts/work/1/s/frontend/pages/scoring/schedules/designer/[[id]]/index.vue?macro=true";
import { default as indexBZ8ExRdXGdUjAzDQr6G1KNrdkeXNSY124TxYLMwF6hEMeta } from "/home/vsts/work/1/s/frontend/pages/scoring/scorecards/designer/[[id]]/index.vue?macro=true";
import { default as index1_45aKp4N21aXHPikgii4srlMUxW04WnOjw4teIqBhU7YMeta } from "/home/vsts/work/1/s/frontend/pages/sentiment/index.vue?macro=true";
import { default as indexv1eATLdjSTkWpF_45KpyDY9HEh6EScs8ACqburPC00MDAMeta } from "/home/vsts/work/1/s/frontend/pages/topics/index.vue?macro=true";
export default [
  {
    name: "auto-qa",
    path: "/auto-qa",
    meta: indexCQsu7M_H3gBwbH9kEvKhE3biZ8fZgVklfGXRAzz1K6AMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/auto-qa/index.vue")
  },
  {
    name: "auto-qa-schedules-designer-id",
    path: "/auto-qa/schedules/designer/:id?",
    meta: indexCIZGGs1bxBvO3kXfORGIqy1KMpPaO3ao96E_WCz4bDcMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/auto-qa/schedules/designer/[[id]]/index.vue")
  },
  {
    name: "auto-qa-scorecards-designer-id",
    path: "/auto-qa/scorecards/designer/:id?",
    meta: indexCLGWLKeW7dHwst0_7Ko8_45j6gDy2d6Qnw08RnWHa4Q90Meta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/auto-qa/scorecards/designer/[[id]]/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexFuSRjEyL1ZhAjMGxhboe4D6qwlHumjbI4109ql4jOuIMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/index.vue")
  },
  {
    name: "interaction-id",
    path: "/interaction/:id()",
    meta: indexLRMqHAF5L3_EoMGh9MqOTQXVRYF9wjaaNx5o8TPJ1WYMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/interaction/[id]/index.vue")
  },
  {
    name: "interactions",
    path: "/interactions",
    meta: indexWj5mu1U5TcmWkORbRmPncXvF6ave2Y59DLCtdbUvQkkMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/interactions/index.vue")
  },
  {
    name: "landing",
    path: "/landing",
    meta: indextxmpD0NLiylCG8zCCjgZtM5HrtaOvTk9ZHVlMxcQLrEMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/landing/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexSRRXWujxOFb_45JLeHuYdW6elKsaT7IOLooo3hFiFJPxkMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/maintenance/index.vue")
  },
  {
    name: "objections",
    path: "/objections",
    meta: indexiol2wFZCm8QJ2oAyoBl4qGW_45k6pVeQRpW3YHOAljMc0Meta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/objections/index.vue")
  },
  {
    name: "overview",
    path: "/overview",
    meta: indexRD0Kv3SnjQ1B7ivS47vqiHs1CB8Ser8D9EZhLSV7264Meta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/overview/index.vue")
  },
  {
    name: "pdfExport",
    path: "/pdfExport",
    meta: indexrjUZpY_45hjJptUJCUWWzpt9nSrH_u5rv_bf4lGJ4s4AcMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/pdfExport/index.vue")
  },
  {
    name: "performance",
    path: "/performance",
    meta: index65ODQZmLCHFepT897IeUw4Cfazfhf_vyzud4zXVPdKMMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/performance/index.vue")
  },
  {
    name: "playback",
    path: "/playback",
    meta: indexGJJNclDeYxhObd51m8MjFlsdpLxpg_un33RIYhp48sEMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/playback/index.vue")
  },
  {
    name: "prompt-studio",
    path: "/prompt-studio",
    meta: index2aG2canzB_5IRkpWAkdnlDd9x7kjuiXUggE0Jspsv_45cMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/prompt-studio/index.vue")
  },
  {
    name: "scorecards-designer-id",
    path: "/scorecards/designer/:id?",
    meta: indexIpSPrdYugpkOYpy6fqrs5EUu37mA7pUahdAK63z9Ij4Meta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/scorecards/designer/[[id]]/index.vue")
  },
  {
    name: "scorecards",
    path: "/scorecards",
    meta: indexKfDJ6LXGmo8X7RhPd0kNs9rSKtWX5kMjdyBAf_YCWYwMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/scorecards/index.vue")
  },
  {
    name: "scoring",
    path: "/scoring",
    meta: indexp49QsU_45j12Sd60L2Aw9gLzeyvKf2VP3ShY0OQCn2jOoMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/scoring/index.vue")
  },
  {
    name: "scoring-schedules-designer-id",
    path: "/scoring/schedules/designer/:id?",
    meta: index1XCdv4fosXiday5au8Fs0NZGDzBt__45SaC82RpYBLICUMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/scoring/schedules/designer/[[id]]/index.vue")
  },
  {
    name: "scoring-scorecards-designer-id",
    path: "/scoring/scorecards/designer/:id?",
    meta: indexBZ8ExRdXGdUjAzDQr6G1KNrdkeXNSY124TxYLMwF6hEMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/scoring/scorecards/designer/[[id]]/index.vue")
  },
  {
    name: "sentiment",
    path: "/sentiment",
    meta: index1_45aKp4N21aXHPikgii4srlMUxW04WnOjw4teIqBhU7YMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/sentiment/index.vue")
  },
  {
    name: "topics",
    path: "/topics",
    meta: indexv1eATLdjSTkWpF_45KpyDY9HEh6EScs8ACqburPC00MDAMeta || {},
    component: () => import("/home/vsts/work/1/s/frontend/pages/topics/index.vue")
  }
]